import {Action, getModule, Module, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {ResponseDataType} from "@/form/form.types";
import {ICounterpartiesType, CounterpartiesTypeResponseType} from "@/entity/finance/counterparties/counterpartiesType.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";

@Module({
    namespaced: true,
    name: 'counterpartyTypes',
    store,
    dynamic: true,
})
class CounterpartiesTypeModule extends VuexModule {
    items: ICounterpartiesType[] | null = null;
    itemsLoading = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ items: ICounterpartiesType[] | null; itemsLoading: boolean }> {
        const items = await store.$repository.counterpartiesType.fetchAll(data);
        let itemsLoading = false;
        if (items) {
            itemsLoading = true;
        }
        return {items, itemsLoading};
    }
    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        const resp = await store.$repository.counterpartiesType.delete({id: id});
        return resp;
    }
}

export const CounterpartiesTypeStore = getModule(CounterpartiesTypeModule);
